import { createContext, useContext, useMemo, useState } from 'react'

import type { MsdfFont, Nullable, Property } from '../../../types'

type FontAtlasType = {
  font: Property<Nullable<MsdfFont>>
}

const stubFunction = () => {
  console.warn('Была вызвана заглушка, возможно, что-то пошло не так')
}

const initialContext: FontAtlasType = {
  font: { value: null, setValue: stubFunction },
}

export const FontAtlasContext = createContext<FontAtlasType>(initialContext)

export const useConstructContext = () => {
  const [font, setFont] = useState<Nullable<MsdfFont>>(null)
  const value = useMemo<FontAtlasType>(
    () => ({
      font: {
        value: font,
        setValue: setFont,
      },
    }),
    [font],
  )

  return value
}

export const useFontAtlas = () => useContext(FontAtlasContext)
